import styled from 'styled-components'

import Arrows from '@public/images/cases/design-991/decorations/arrows.svg'

export const StyledArrows = styled(Arrows)`
  margin-bottom: 40px;
`

export const BackgroundWrapper = styled.div`
  background: ${({ theme }) => theme.colors.gradientGray};
`

export const BackgroundDecorativeWrapper = styled.div`
  background-image: url('/images/cases/design-991/decorations/header-desktop.webp');
  background-position-x: right;
  background-position-y: 60%;
  background-repeat: no-repeat;
  background-size: 40% auto;
  margin: 0 auto;
  max-width: 1310px;
  width: 100%;
  ${({ theme }) => theme.below.laptop`
    background-image: url('/images/cases/design-991/decorations/header-mobile.webp');
    background-position-x: center;
    background-position-y: 40%;
    background-size: 380px 350px;
  `}
`

export const OrangeText = styled.span`
  color: #ffb366;
`

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.milkyWhite};
  font-size: 98px;
  font-weight: ${({ theme }) => theme.fontWeight[6]};
  line-height: ${({ theme }) => theme.lineHeight[9]}px;
  margin-bottom: ${({ theme }) => theme.spaces[4]}px;
  text-transform: uppercase;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[7]}px;
    line-height: 67px;
  `}
`

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.milkyWhite};
  font-size: 50px;
  font-weight: ${({ theme }) => theme.fontWeight[4]};
  line-height: ${({ theme }) => theme.fontSizes[19]}px;
  margin-bottom: 52px;
  max-width: 700px;

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[2]}px;
    line-height: ${theme.lineHeight[6]}px;
    margin-bottom: 350px;
  `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 150px;
  position: relative;
  ${({ theme }) => theme.below.laptop`
    margin-top: 40px;
    padding: 40px;
  `}
`

export const Tag = styled.div`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 100px;
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: ${({ theme }) => theme.lineHeight[6]}px;
  padding: 12px 24px;

  &:first-child {
    margin-left: 0;
  }
`

export const TagsWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.milkyWhite};
  display: flex;
  flex-wrap: wrap;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  gap: ${({ theme }) => theme.spaces[4]}px;
  margin-bottom: 50px;

  ${({ theme }) => theme.below.laptop`
    width: 300px;
  `}
`
